<script>
    import { AjaxCaller } from '@ssdcode/cms-partials';
    export default {
        mixins: [AjaxCaller],
        props: {
            success: {
                type: Function,
                required: true
            }
        },
        methods: {
            call() {
                if (this.processing) {
                    return;
                }
                this.makeAjaxRequest(this.success, this.failure);
            },
            failure(error) {
                this.stopProcessing();
                throw new Error(error);
            }
        },
        render() {
            return this.$scopedSlots.default({
                call: this.call,
                processing: this.processing,
            });
        }
    }
</script>